<app-formulario #ctrl URL="calificacion" titulo="Calificación / Control Escolar" [dato]="dato"></app-formulario>

<app-sistema-menu></app-sistema-menu>
<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; height:100%;">
            <form name="form" novalidate>
                <section class="hero is-primary">
                    <div class="hero-body">
                        <section class="hero is-primary">
                            <div class="hero-head">
                              <nav class="level">
                                <!-- Left side -->
                                <div class="level-left">
                                  <div class="level-item">
                                  <p class="title">
                                       <!--  <span *ngIf="!ctrl.cargando" class="icon is-medium">
                                        <i class="icon-computer6"></i>
                                      </span>
                                      <span *ngIf="ctrl.cargando  || cargando" class="icon is-medium">
                                        <i class="icon-worldwide fa-spin"></i>
                                      </span>-->
                                      <span class="icon is-medium">
                                        <i class="icon-computer-12"></i>
                                      </span> Monitor Reprobados
                                    </p> 
                                  </div>
              
                                </div>
              
                                <!-- Right side -->
                                <div class="level-right">
              
                                  <!-- <a class="navbar-item is-primary tooltip" (click)="ctrl.regresar()">
                                    <span class="icon fa-2x">
                                      <i class="icon-back"> </i>
                                    </span>
                                    <span class="tooltiptext">Regresar</span>
                                  </a>
              
                                  <a class="navbar-item is-primary tooltip" (click)="cargarDatos()">
                                    <span class="icon fa-2x has-text-success">
                                      <i class="icon-search "></i>
                                    </span>
                                    <span class="tooltiptext">Buscar Boletas</span>
                                  </a>
              
                                  <a class="navbar-item is-primary tooltip" (click)="verDatosHistorial()">
                                    <span class="icon fa-2x has-text-link">
                                      <i class="icon-search "></i>
                                    </span>
                                    <span class="tooltiptext">Buscar Historia y Certificados</span>
                                  </a> -->
                                </div>
                              </nav>
                            </div>
                          </section>
                    </div>
                </section>

                <a id="catalogos"
                (click)="ctrl.cargarCatalogo('periodos_escolares', 'periodo-escolar-catalogo', '', 'cargando_periodo');  ctrl.cargarCatalogo('logos64', 'logos64', 'logo64');"></a>
              <a id="logo64" (click)="asignarLogos(ctrl.logos64); "></a>
      

                <section class="section" style="overflow-y:auto; overflow-x:hidden; padding: 1rem; height: 86vh;">
                    <div class="columns">
                        <div class="column is-12">
                            <label class="label">Período escolar:</label>
                            <div class="control has-icons-left has-icons-right">
                              <span class="icon is-small is-left">
                                <i class="icon-worldwide fa-spin" *ngIf="ctrl.cargando_periodo"></i>
                              </span>
                              <ng-select2
                                [disabled]="activos ? true :ctrl.periodos_escolares ? ctrl.periodos_escolares.length == 0 ? true : false : true"
                                [options]="ctrl.optionSelect"
                                (valueChanged)="seleccionarPeriodo($event); ctrl.grupos = []; $event ? ctrl.catalogoDependiente('grupo-periodo', 'grupos', ($event.hasOwnProperty('value') ? $event.value : $event)) : '';"
                                [data]="ctrl.periodos_escolares"></ng-select2>
                            </div>
                        </div>
                    </div>
                </section>  
            </form>
        </div>
    </div>
</div>